function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import "cross-fetch/polyfill";
import { Base } from "@logtail/core"; // Awaiting: https://bugs.chromium.org/p/chromium/issues/detail?id=571722
// import { getUserAgent } from "./helpers";

export var Browser = /*#__PURE__*/function (_Base) {
  _inherits(Browser, _Base);

  var _super = _createSuper(Browser);

  function Browser(sourceToken, options) {
    var _this;

    _classCallCheck(this, Browser);

    // After reaching 48KiB, the batch will get flushed automatically to avoid 64KiB body limit for keepalive requests
    _this = _super.call(this, sourceToken, Object.assign({
      batchSizeKiB: 48
    }, options)); // Sync function

    var sync = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(logs) {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(_this._options.endpoint, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(_this._sourceToken) // Awaiting: https://bugs.chromium.org/p/chromium/issues/detail?id=571722
                    // "User-Agent": getUserAgent()

                  },
                  body: JSON.stringify(logs),
                  keepalive: true
                });

              case 2:
                res = _context.sent;

                if (!res.ok) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", logs);

              case 5:
                throw new Error(res.statusText);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function sync(_x) {
        return _ref.apply(this, arguments);
      };
    }(); // Set the throttled sync function


    _this.setSync(sync);

    _this.configureFlushOnPageLeave();

    return _this;
  }
  /**
   * Override `Base` log to add browser-specific context
   *
   * @param message: string - Log message
   * @param level (LogLevel) - Level to log at (debug|info|warn|error)
   * @param context: (Context) - Log context for passing structured data
   * @returns Promise<ILogtailLog> after syncing
   */


  _createClass(Browser, [{
    key: "log",
    value: function () {
      var _log = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(message, level) {
        var context,
            wrappedContext,
            _wrappedContext,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                context = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};

                // Wrap context in an object, if it's not already
                if (_typeof(context) !== "object") {
                  wrappedContext = {
                    extra: context
                  };
                  context = wrappedContext;
                }

                if (context instanceof Error) {
                  _wrappedContext = {
                    error: context
                  };
                  context = _wrappedContext;
                }

                context = Object.assign(Object.assign({}, this.getCurrentContext()), context);
                return _context2.abrupt("return", _get(_getPrototypeOf(Browser.prototype), "log", this).call(this, message, level, context));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function log(_x2, _x3) {
        return _log.apply(this, arguments);
      }

      return log;
    }()
  }, {
    key: "getCurrentContext",
    value: function getCurrentContext() {
      var _a, _b, _c;

      var context = {};

      if (typeof window !== "undefined") {
        context.url = (_a = window.location) === null || _a === void 0 ? void 0 : _a.href;
        context.device_pixel_ratio = window.devicePixelRatio;
        context.screen_width = (_b = window.screen) === null || _b === void 0 ? void 0 : _b.width;
        context.screen_height = (_c = window.screen) === null || _c === void 0 ? void 0 : _c.height;
        context.window_width = window.innerWidth;
        context.window_height = window.innerHeight;
      }

      if (typeof navigator !== "undefined") {
        context.user_locale = navigator.userLanguage || navigator.language;
        context.user_agent = navigator.userAgent;
      }

      return context;
    }
  }, {
    key: "configureFlushOnPageLeave",
    value: function configureFlushOnPageLeave() {
      var _this2 = this;

      if (typeof document === "undefined") {
        return;
      }

      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") {
          _this2.flush();
        }
      });
    }
  }]);

  return Browser;
}(Base);